import React, { useContext } from "react";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import viewDocumentLink from "../../../api/viewDocumentLink";
import sendOtpToEmail from "../../../api/sendOtpToEmail";
import { AuthContext } from "../../../context/Auth/AuthContext";
import baseUrl from "../../../config/baseUrl";
import { CopyActionButton } from "../../common/ActionIconButton";

/*** Component for copying the document link from the mailroom section ***/
const CopyLinkPopup = ({ caseNo, tableValues }) => {
  const { token } = useContext(AuthContext);

  const copyLink = () => {
    const copyLink = async () => {
      // // First, send OTP to the user's email
      // const otpResponse = await sendOtpToEmail({ token, email_id });

      // if (otpResponse?.code === 200) {
      // OTP sent successfully
      const downloadLinkFormResponse = await viewDocumentLink({
        token: token,
        docId: tableValues.documentID,
      });

      if (
        downloadLinkFormResponse?.code === 200 &&
        downloadLinkFormResponse?.data[0]?.pdflink &&
        tableValues?.contact_id
      ) {
        const link = downloadLinkFormResponse?.data[0].pdflink;
        const filename = link.split("/").pop();
        const viewDocUrl = `${baseUrl}/api/view-doc/${tableValues?.contact_id}/${filename}`;
        navigator.clipboard.writeText(viewDocUrl);
        showSuccess("Link copied successfully to view the Document");
      } else {
        showError("Copy URL does not exist");
      }
      // } else {
      //   showError("Failed to send OTP. Please try again later.");
      // }
    };

    copyLink();
  };

  return (
    <CopyActionButton
      onClick={copyLink}
      disabled={tableValues?.contact_id === null}
    />
  );
};

export default CopyLinkPopup;
